import { sortedPageHeading } from '../utils/listing-sort';

interface CategorySectionHeaderProps {
  categorySlug: string;
  categoryName: string;
  categoryHeading?: string;
  /** The page's `?sortBy=`; the heading names it (utils/listing-sort.ts). */
  sortBy?: unknown;
}

export default function CategorySectionHeader({
  categorySlug: _categorySlug,
  categoryName,
  categoryHeading = 'Browse',
  sortBy,
}: CategorySectionHeaderProps) {
  return (
    <h2 className="browse-heading">
      {sortedPageHeading(categoryName, sortBy, categoryHeading.trim())}
    </h2>
  );
}
